import React, { useEffect, useState } from 'react';
import { Loader2, Sparkles } from 'lucide-react';
import api, { errText } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

const AdminChat = () => {
  const { toast } = useToast();
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/admin/chat/config').then((r) => setEnabled(!!r.data?.enabled)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const toggle = async () => {
    const next = !enabled;
    setSaving(true);
    try {
      await api.put('/admin/chat/config', { enabled: next });
      setEnabled(next);
      toast({ title: next ? 'Seeker\'s Guide turned ON' : 'Seeker\'s Guide turned OFF', description: next ? 'The AI chat is now live on the website.' : 'The AI chat is hidden from visitors.' });
    } catch (e) { toast({ title: 'Could not update', description: errText(e) }); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-mahogany" /></div>;

  return (
    <div className="space-y-6 max-w-2xl" data-testid="admin-chat-page">
      <div>
        <h1 className="font-serif-display text-3xl text-burgundy flex items-center gap-2"><Sparkles className="w-6 h-6" /> AI Chat — Seeker's Guide</h1>
        <p className="text-mahogany/70 text-sm">Turn the AI chat assistant on or off across your website (floating bubble + the /ask page).</p>
      </div>

      <div className="rounded-3xl border border-rose/40 bg-white/70 p-6 flex items-center justify-between">
        <div>
          <div className="font-medium text-burgundy">{enabled ? 'AI Chat is ON' : 'AI Chat is OFF'}</div>
          <div className="text-sm text-mahogany/70">{enabled ? 'Visitors can chat with the Seeker\'s Guide everywhere on the site.' : 'The chat bubble and Ask page are hidden from visitors.'}</div>
        </div>
        <button
          onClick={toggle}
          disabled={saving}
          data-testid="chat-toggle"
          role="switch"
          aria-checked={enabled}
          className={`relative inline-flex h-8 w-14 items-center rounded-full transition-colors ${enabled ? 'bg-mahogany' : 'bg-mahogany/25'}`}
        >
          <span className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition-transform ${enabled ? 'translate-x-7' : 'translate-x-1'}`} />
        </button>
      </div>

      <p className="text-xs text-mahogany/55">
        Note: the AI runs on your Emergent Universal Key and consumes credits per conversation while it is ON.
        Turning it OFF stops all usage and cost immediately.
      </p>
    </div>
  );
};

export default AdminChat;
